import { render } from "./NotFound.vue?vue&type=template&id=461ab4e6"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grntm\\OneDrive\\Study\\Vue Mastery\\real-world-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__